const Stats = () => {
  return (
    <section className="bg-white h-1 py-12">
    
    </section>
  );
};

export default Stats;